import { defineStore } from 'pinia'
import { getCurrentLocale } from '@/i18n'


export const MENU_KEY = "web-menu";
export const PERSON_MENU_KEY = "web-menu-person";
export const PERMISSIONS_KEY = "web-permissions";
// Locale the cached menu was fetched under. The menu labels are localised by
// the backend (sys_menu.name_en_hk / name_zh_hk), so a cache fetched under one
// locale must be re-fetched when the UI locale changes — see layout/index.vue.
export const MENU_LOCALE_KEY = "web-menu-locale";

interface MENU {
  menu: any[]
  personMenu: any[]
  permissions: any[]
}

export const useMenuStore = defineStore('menu', {
  state: (): MENU => ({
    menu: [],
    personMenu: [],
    permissions: []
  }),
  actions: {
    getMenu() {
      const menu = window.localStorage.getItem(MENU_KEY)
      const permissions = window.localStorage.getItem(PERMISSIONS_KEY)
      if (menu && permissions) {
        try {
          this.menu = JSON.parse(menu) as any[];
          this.permissions = JSON.parse(permissions) as any[];
        } catch (_e) { }
      }
    },
    getPersonMenu() {
      const menu: any = window.localStorage.getItem(PERSON_MENU_KEY)
      const permissions = window.localStorage.getItem(PERMISSIONS_KEY)
      if (menu && permissions) {
        try {
          this.personMenu = JSON.parse(menu) as any[];
          this.permissions = JSON.parse(permissions) as any[];
        } catch (_e) { }
      }
    },
    setPersonMenu(menu: any, permissions:any) {
      if (menu) {
        window.localStorage.setItem(PERSON_MENU_KEY, JSON.stringify(menu))
      }
      this.setMenu(undefined, permissions)
    },
    setMenu(menus: any, permissions: any) {
      let oldPermissions:any = window.localStorage.getItem(PERMISSIONS_KEY);
      if (oldPermissions) {
        try {
          oldPermissions = JSON.parse(oldPermissions) as any[];
          permissions = permissions.concat(oldPermissions);
        } catch (_e) { }
      }

      if (menus) {
        window.localStorage.setItem(MENU_KEY, JSON.stringify(menus))
        window.localStorage.setItem(MENU_LOCALE_KEY, getCurrentLocale())
      }
      if (permissions) {
        window.localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions))
      }
    },
    // Replace the cached menu in-place (reactive state + localStorage) after a
    // locale-driven re-fetch. Unlike setMenu it leaves permissions untouched —
    // permissions don't change with locale, and re-running setMenu would keep
    // concatenating them onto the stored list.
    refreshMenu(menus: any) {
      if (menus) {
        window.localStorage.setItem(MENU_KEY, JSON.stringify(menus))
        window.localStorage.setItem(MENU_LOCALE_KEY, getCurrentLocale())
        this.menu = menus as any[]
      }
    }
  }
})